<div class="container-fluid pb-5 user-membership-detail-page bg-light">
  <div class="text-left mb-4">
    <h3 class="fw-bold text-dark">
      <span class="lstick"></span> User Membership Details
    </h3>
    <p class="text-muted mb-0">
      View detailed information about the user’s membership
    </p>
  </div>

  <div *ngIf="details" class="row justify-content-center g-4">
    <div class="col-lg-9">
      <div class="card modern-card mb-4">
        <div class="card-header">
          <i class="fa fa-credit-card text-success mr-2"></i> Membership
          Information
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="small text-muted">Membership Name</label>
              <h6 class="fw-semibold text-dark">
                {{ details?.membershipId?.name }}
              </h6>
            </div>
            <div class="col-md-6">
              <label class="small text-muted">Description</label>
              <p class="mb-0">
                {{ details?.membershipId?.description }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- PRICING DETAILS -->
      <div class="card modern-card mb-4">
        <div class="card-header">Pricing Details</div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="small text-muted">Total Price</label>
              <h5 class="fw-bold text-primary mb-0">
                {{ details?.countryObject?.currency }}
                {{ details?.chargeableAmount / 100 || 0 }}
              </h5>
            </div>
            <div class="col-md-4">
              <label class="small text-muted">VAT (%)</label>
              <p class="fw-semibold">{{ details?.vat || 0 }}%</p>
            </div>
            <div class="col-md-4">
              <label class="small text-muted">VAT Amount</label>
              <p class="fw-semibold">
                {{ details?.countryObject?.currency }}
                {{ details?.vatAmount || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- BENEFITS & LIMITS -->
      <div class="card modern-card mb-4">
        <div class="card-header">
          <i class="fa fa-gift text-warning mr-2"></i> Benefits & Limits
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="small text-muted">Free Products</label>
              <h6 class="fw-semibold">{{ details?.freeProduct || 0 }}</h6>
            </div>

            <!-- <div class="col-md-4">
              <label class="small text-muted">Product Limit</label>
              <h6 class="fw-semibold">{{ details?.productLimit || 0 }}</h6>
            </div> -->
            <div class="col-md-4">
              <label class="small text-muted">Free Shipment</label><br />
              <h6 class="fw-semibold">
                {{ details?.freeShipment ? "Yes" : "No" }}
              </h6>
            </div>
          </div>

          <div *ngIf="details?.membershipId?.features?.length" class="mt-4">
            <label class="small text-muted">Features</label>
            <ul class="list-group modern-list">
              <li
                class="list-group-item border-0 d-flex align-items-center py-2"
                *ngFor="let f of details?.membershipId?.features"
              >
                <i class="fa fa-check-circle text-success mr-2"></i>{{ f }}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- DURATION & DATES -->
      <div class="card modern-card mb-4">
        <div class="card-header">
          <i class="fa fa-calendar-alt text-secondary mr-2"></i> Duration &
          Dates
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="small text-muted">Duration</label>
              <h6 class="fw-semibold">
                {{ details?.duration }} {{ details?.timing | titlecase }}
              </h6>
            </div>
            <div class="col-md-4">
              <label class="small text-muted">Start Date</label>
              <p class="fw-semibold">
                {{ details?.startDate | date : "short" }}
              </p>
            </div>
            <div class="col-md-4">
              <label class="small text-muted">End Date</label>
              <p class="fw-semibold">
                {{ details?.endDate | date : "short" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-3">
      <div class="card modern-card mb-4">
        <div class="card-header">
          <i
            class="fa fa-user-circle mr-2 text-primary"
            style="font-size: 20px"
          ></i>
          User Information
        </div>
        <div class="card-body">
          <div class="text-left mb-3">
            <h5 class="fw-bold text-dark mb-1">
              {{ details?.user_id?.username }}
            </h5>
            <p class="text-muted small mb-2">{{ details?.user_id?.email }}</p>
          </div>

          <hr />

          <div class="mb-2">
            <label class="small text-muted d-block">Exclusive</label>
            <span
              class="badge rounded-pill px-3 py-2"
              [ngClass]="
                details?.isExclusive
                  ? 'bg-warning text-dark'
                  : 'bg-secondary text-white'
              "
            >
              {{ details?.isExclusive ? "Yes" : "No" }}
            </span>
          </div>

          <div class="mb-2">
            <label class="small text-muted d-block">Status</label>
            <span
              class="badge rounded-pill px-3 py-2 text-white"
              [ngClass]="details?.active ? 'bg-success' : 'bg-danger'"
            >
              {{ details?.active ? "Active" : "Inactive" }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
